import { clomp } from 'clomp';

export const Container = clomp.div`
  bg-white
  flex
  flex-col
  relative
`;
